import React from 'react';
import {Box, Stack} from '@mui/material';
import PropTypes from 'prop-types';

const categoryColours = {
    Admissions: '#0dad95',
    Boarding: '#dc2626',
    Staff: '#eab308',
    General: '#2563eb',
    Blank: '#d0d0d0',
};

const EmailPreviewVisual = ({category}) => {
    const bg = categoryColours[category] || categoryColours.General;

    return (
        <Box
            sx={{
                width: '100%',
                height: '65%',
                backgroundColor: bg,
                p: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '80%',
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 3px 8px rgba(0,0,0,0.1)',
                }}
            >
                {/* Header: sender + time */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 1.2,
                        borderBottom: '1px solid #f0f0f0',
                        backgroundColor: '#f9fafb',
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <Box
                            sx={{
                                width: 18,
                                height: 18,
                                borderRadius: '50%',
                                backgroundColor: bg,
                            }}
                        />
                        <Stack spacing={0.4}>
                            <Box
                                sx={{
                                    width: 70,
                                    height: 8,
                                    borderRadius: 1,
                                    backgroundColor: '#e5e7eb',
                                }}
                            />
                            <Box
                                sx={{
                                    width: 110,
                                    height: 6,
                                    borderRadius: 1,
                                    backgroundColor: '#e5e7eb',
                                }}
                            />
                        </Stack>
                    </Box>

                    <Box
                        sx={{
                            width: 36,
                            height: 8,
                            borderRadius: 999,
                            backgroundColor: '#e5e7eb',
                        }}
                    />
                </Box>

                {/* To + subject + body */}
                <Box
                    sx={{
                        flexGrow: 1,
                        px: 1.5,
                        pt: 1.2,
                    }}
                >
                    {/* To row */}
                    <Stack spacing={0.7}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.8,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 20,
                                    height: 8,
                                    borderRadius: 1,
                                    backgroundColor: '#e5e7eb',
                                }}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 0.6,
                                }}
                            >
                                {[...Array(3)].map((_, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            height: 14,
                                            minWidth: 38,
                                            px: 0.6,
                                            borderRadius: 999,
                                            backgroundColor: '#e5e7eb',
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>

                        {/* Subject */}
                        <Box
                            sx={{
                                height: 12,
                                width: '92%',
                                borderRadius: 1,
                                backgroundColor: '#cbd5e1',
                                mt: 0.5,
                            }}
                        />

                        {/* Body lines */}
                        <Stack spacing={0.6} mt={1}>
                            <Box
                                sx={{
                                    height: 8,
                                    width: '96%',
                                    borderRadius: 1,
                                    backgroundColor: '#e5e7eb',
                                }}
                            />
                            <Box
                                sx={{
                                    height: 8,
                                    width: '70%',
                                    borderRadius: 1,
                                    backgroundColor: '#e5e7eb',
                                }}
                            />
                        </Stack>
                    </Stack>
                </Box>

                {/* Footer: send bar */}
                <Box
                    sx={{
                        height: 30,
                        backgroundColor: '#f3f4f6',
                        borderTop: '1px solid #e5e7eb',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1.4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8
                    }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 8,
                                borderRadius: 999,
                                backgroundColor: '#e5e7eb',
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.6,
                        }}
                    >

                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

EmailPreviewVisual.propTypes = {
    category: PropTypes.string,
};

export default EmailPreviewVisual;
